export type ChatMessageStatusKind = "sent" | "delivered" | "read" | "failed";

export function getChatMessageStatusColor(
  kind: ChatMessageStatusKind,
  isDarkBackground: boolean,
) {
  if (kind === "failed") {
    return isDarkBackground ? "text-red-200" : "text-red-500";
  }

  if (isDarkBackground) {
    return kind === "read" ? "text-white" : "text-white/85";
  }

  return "text-blue-500";
}